import { snakeCase } from '../../client/utils/string/string';

export function serializeParams(obj: object, result: object = {}, parentKey: string = '') {
  // eslint-disable-next-line consistent-return
  Object.keys(obj).forEach((key) => {
    const value = obj[key];
    const newKey = `${parentKey}_${key}`;

    if (typeof value === 'object' && !Array.isArray(value) && !(value instanceof Date)) {
      return serializeParams(value, result, newKey);
    }

    result[snakeCase(newKey)] = value instanceof Date ? value.toISOString() : value;
  });

  return result;
}

export function serializeRadius<T extends { radius?: number }>(object: T) {
  return object.radius
    ? { radius: `${object.radius.toFixed(0)}km` }
    : {};
}
